export default __webpack_public_path__ + "static/media/xmas.109940cb.jpg";